import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import TableLabels from "./TableLabels";
import AxiosController from "../../../authentication/AxiosController";
import { notifyError } from "../../../toastify/toastify";
import { Button, Modal } from "react-bootstrap";
import IconsGen from "../../../icons_generator/IconsGen";

const SuppliersTableRow = ({ payments_list, get_warehouses }) => {
  const { slug, lang } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("global");
  const token = localStorage.getItem("token");
  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const [radio, setRadio] = useState("1");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [formData, setFormData] = useState({
    fulfillment_price: "",
    confirmation_price: "",
    cancellation_price: "",
    post_delivery_charge: "",
  });

  // Add error states
  const [fulfillmentProfitErr, setFulfillmentProfitErr] = useState("");
  const [confirmationPriceErr, setConfirmationPriceErr] = useState("");
  const [cancellationErr, setCancellationErr] = useState("");
  const [postDeliveryChargeErr, setPostDeliveryChargeErr] = useState("");

  const handleEditClick = (order) => {
    setSelectedOrder(order);
    setFormData({
      fulfillment_price: order.fulfillment_price || "",
      confirmation_price: order.confirmation_price || "",
      cancellation_price: order.cancellation_price || "",
      post_delivery_charge: order.post_delivery_charge || "",
    });
    setIsModalOpen(true);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (!selectedOrder) return;

    try {
      const response = await AxiosController.post(
        `api/${slug}/${lang}/fulfillments/new`,
        {
          user_id: selectedOrder.seller_id,
          ...formData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );


      setIsModalOpen(false);

      // Fetch updated warehouse data after successful update
      get_warehouses();

    } catch (e) {
      if (e.response?.data?.error) {
        Object.entries(e.response.data.error).forEach(([key, value]) => {
          Array.isArray(value)
            ? value.forEach((err) => notifyError(`${key}: ${err}`))
            : notifyError(`${key}: ${value}`);
        });
      } else {
        notifyError("An unexpected error occurred.");
      }
    }
  };


  return (
    <div
      className={`table-responsive my-3 d-flex ${lang === "en" ? "flex-row" : "flex-row-reversed"
        } align-items-center`}
    >
      <table className="table table-borderless">
        <thead>
          <TableLabels />
        </thead>
        <tbody>
          {payments_list.map((order) => {
            const dateSegments = order?.created_at_formatted.split(" ");
            return (
              <tr key={order?.id}>
                <td className="align-middle">
                  {dateSegments[0]} <br /> {dateSegments[1]} {dateSegments[2]}
                </td>
                <td className="align-middle">
                  <span className="fw-bold">{order?.user.id} #</span>
                  <br /> {order?.user.first_name} {order?.user.last_name}
                </td>
                <td className="align-middle">{order?.fulfillment_price}</td>
                <td className="align-middle">{order?.confirmation_price}</td>
                <td className="align-middle">{order?.cancellation_price}</td>  
                 <td className="align-middle">{order?.post_delivery_charge || '_'}</td>
                 <td className="align-middle">
                  <span
                    onClick={() => navigate(`/${slug}/${lang}/panel/settings/fulfillment/govs/${order.user.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <IconsGen icon_name="enter" />
                  </span>
                </td>
                <td className="align-middle">
                  <span
                    onClick={() => handleEditClick(order)}
                    style={{ cursor: "pointer" }}
                  >
                    <IconsGen icon_name="enter" />
                  </span>
                </td>

              </tr>
            );
          })}
        </tbody>
      </table>

      <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
        <Modal.Header closeButton className="border-0" dir={box_head_dir}>
          <Modal.Title className="flex-grow-1">{t("panel.update")}</Modal.Title>
        </Modal.Header>
        <Modal.Body dir={box_head_dir}>
        <div className="mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="chargeType"
                id="type1"
                value="1"
                checked={radio === "1"}
                onChange={(e) => {
                  setRadio(e.target.value);
                  setFormData(prev => ({ ...prev, post_delivery_charge: 0 }));
                  setPostDeliveryChargeErr("");
                }}
              />
              <label className="form-check-label" htmlFor="type1">
                {t("panel.fulfillment_charges")}
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="chargeType"
                id="type2"
                value="2"
                checked={radio === "2"}
                onChange={(e) => {
                  setRadio(e.target.value);
                  setFormData(prev => ({
                    ...prev,
                    fulfillment_price: 0,
                    confirmation_price: 0,
                    cancellation_price: 0
                  }));
                  setFulfillmentProfitErr("");
                  setConfirmationPriceErr("");
                  setCancellationErr("");
                }}
              />
              <label className="form-check-label" htmlFor="type2">
                {t("panel.post_delivery_charges")}
              </label>
            </div>
          </div>

          {radio === "1" ? (
            <>
              <div className="mb-3">
                <label htmlFor="fulfillment_price" className="form-label">
                  {t("panel.fulfillmentprofit")}
                </label>
                <input
                  type="text"
                  id="fulfillment_price"
                  className="form-control py-2"
                  name="fulfillment_price"
                  value={formData.fulfillment_price}
                  onChange={handleInputChange}
                  placeholder={t("panel.fulfillmentprofit")}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="confirmation_price" className="form-label">
                  {t("panel.confirmation_price")}
                </label>
                <input
                  type="text"
                  id="confirmation_price"
                  className="form-control py-2"
                  name="confirmation_price"
                  value={formData.confirmation_price}
                  onChange={handleInputChange}
                  placeholder={t("panel.confirmation_price")}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="cancellation_price" className="form-label">
                  {t("panel.cancellationprofit")}
                </label>
                <input
                  type="text"
                  id="cancellation_price"
                  className="form-control py-2"
                  name="cancellation_price"
                  value={formData.cancellation_price}
                  onChange={handleInputChange}
                  placeholder={t("panel.cancellationprofit")}
                />
              </div>
            </>
          ) : (
            <div className="mb-3">
              <label htmlFor="post_delivery_charge" className="form-label">
                {t("panel.post_delivery_charge")}
              </label>
              <input
                type="text"
                id="post_delivery_charge"
                className="form-control py-2"
                name="post_delivery_charge"
                value={formData.post_delivery_charge}
                onChange={handleInputChange}
                placeholder={t("panel.post_delivery_charge")}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0" dir={box_head_dir}>
          <Button variant="primary" onClick={handleSave}>
            {t("panel.save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SuppliersTableRow;
